import Label from "./Label";
import FormGroup from "./FormGroup";
import Input from "./Input";
const CommonRadioGroup = ({
  name,
  label,
  options = [],
  value,
  onChange,
  required = false,
  className = "",
  error,
  touched,
}) => {
  return (
    <div className={`common-radio-row ${className}`}>

      {/* First Row */}
      <div className="radio-main-row">
        <Label className="common-radio-label mb-0">
          {label}
          {required && <span className="text-danger">*</span>}
        </Label>

        <div className="common-radio-options">
          {options.map((option, index) => (
            <FormGroup
              key={index}
              className="form-check d-flex align-items-center gap-1"
            >
              <Input
                type="radio"
                id={`${name}_${option.value}`}
                name={name}
                value={option.value}
                checked={String(value) === String(option.value)}
                onChange={onChange}
                className="form-check-input cursor-pointer"
              />
              <Label
                htmlFor={`${name}_${option.value}`}
                className="form-check-label ms-1 mb-0 cursor-pointer"
              >
                {option.label}
              </Label>
            </FormGroup>
          ))}
        </div>
      </div>

      {/* Error Row */}
      {touched && error && (
        <div className="radio-error text-danger small">
          {error}
        </div>
      )}

    </div>
  );
};

export default CommonRadioGroup;